export default "__VITE_ASSET__DXubqyBy__"